import type { AluminiumAISampleComposition, SpecificationListItem } from 'api';
import { Stack } from 'ui';

import { buildAluAiLooseCompositionItems } from '../../utils/buildAluAiLooseCompositionItems/buildAluAiLooseCompositionItems';
import { MaterialBreakdownItem } from '../MaterialBreakdownItem/MaterialBreakdownItem';

export const AiAluSampleBreakdown = ({
  composition,
  totalWeight,
  instructions,
}: {
  composition: AluminiumAISampleComposition;
  totalWeight: number;
  instructions?: SpecificationListItem[];
}) => {
  const { targetAluminiumSection, nonTargetSection, totalItem } = buildAluAiLooseCompositionItems(
    composition,
    totalWeight,
    instructions
  );

  return (
    <Stack
      data-testid="ai-alu-sample-breakdown"
      sx={{
        gap: 2,
      }}
    >
      <div>
        {targetAluminiumSection.items.map((item, index) => (
          <MaterialBreakdownItem
            key={`${item.label}-${index}`}
            label={item.label}
            value={item.value}
            secondaryValue={item.secondaryValue}
            highlight={item.highlight}
            variant={item.variant}
            dataTestId={item.dataTestId}
          />
        ))}
      </div>
      <div>
        {nonTargetSection.items.map((item, index) => (
          <MaterialBreakdownItem
            key={`${item.label}-${index}`}
            label={item.label}
            value={item.value}
            secondaryValue={item.secondaryValue}
            highlight={item.highlight}
            variant={item.variant}
            dataTestId={item.dataTestId}
          />
        ))}
      </div>
      <MaterialBreakdownItem
        label={totalItem.label}
        value={totalItem.value}
        secondaryValue={totalItem.secondaryValue}
        variant={totalItem.variant}
      />
    </Stack>
  );
};
